//This provides a source to backend and by default it will return Store.

export function languageIdentifier(selectedLanguage: string = "en") {
  const language = 1; // default
  const source = {
    en: 1,
    ar: 2,
  };
  return source[selectedLanguage] ? source[selectedLanguage] : language;
}
